import React, { useEffect, useState } from 'react';

import { useTranslation } from '@common/hooks/translation';

const EmbedPopup = ({ links, closePopup, className }) => {
  const t = useTranslation();
  const [file, setFile] = useState(null);
  
  useEffect(() => {
    const loadFile = async () => {
      try {
        const fileModule = await import(/* @vite-ignore */ `/dev/rules/${links}`);
        setFile(fileModule.default || fileModule);
      } catch {
        // If it's already a URL or path, use it directly
        setFile(links);
      }
    };
    
    loadFile();
  }, [links]);

  if (!file) return null;

  return (
    <div className={`popup-content popup-frame ${className}`}>
      <div className="popup-main-content">
        <embed
          src={`${file}#toolbar=0&navpanes=0&scrollbar=0&zoom=108`}
          width="100%"
          height="100%"
        />
      </div>
      <button
        type="button"
        onClick={() => {
          closePopup();
        }}
        className="popup-cancel-button"
      >
        {t('Cancel')}
      </button>
    </div>
  );
};

export default EmbedPopup;
